module.exports = __webpack_public_path__ + "img/08.63575270.jpg";